import type { TToolArgumentEditor, TToolArgument } from '@intone/shared/types';

export function packArguments(args: TToolArgumentEditor[]): TToolArgument {
  const out: TToolArgument = {};
  args.forEach(a => {
    if (!a.name) return;
    const entry: TToolArgument[string] = {
      value: a.value,
      valueType: a.valueType,
      is_required: a.is_required,
    };
    if (a.argType) entry.argType = a.argType;
    out[a.name] = entry;
  });
  return out;
}
